import { render, staticRenderFns } from "./GeneralTermsClient.vue?vue&type=template&id=f094b6d4&scoped=true"
import script from "./GeneralTermsClient.vue?vue&type=script&lang=js"
export * from "./GeneralTermsClient.vue?vue&type=script&lang=js"
import style0 from "./GeneralTermsClient.vue?vue&type=style&index=0&id=f094b6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f094b6d4",
  null
  
)

export default component.exports